/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-selectbox[_ngcontent-%COMP%]{width:100%;margin:21px 0 16px}ui-selectbox[_ngcontent-%COMP%]:first-of-type{margin:0 0 16px}ui-selectbox[_ngcontent-%COMP%]:last-of-type{margin:21px 0 0}"];
export { styles as styles };
